module.exports = __webpack_public_path__ + "img/54741bd04ff14b6b8351a9fe87decfc3.0eebde44.jpg";